export default __webpack_public_path__ + "static/media/reserve.fe575e65.svg";